import { isModuleEntitlement } from "@nahal/api-client";

export type EntitlementRow = { key: string; value: string };

export function reservedEntitlement(key: string, moduleAccessEnabled: boolean): boolean {
  return moduleAccessEnabled && isModuleEntitlement(key.trim());
}

export function entitlementRows(entitlements: Record<string, string>, moduleAccessEnabled: boolean): EntitlementRow[] {
  return Object.entries(entitlements)
    .filter(([key]) => !reservedEntitlement(key, moduleAccessEnabled))
    .map(([key, value]) => ({ key, value }));
}

export function entitlementPayload(rows: EntitlementRow[], moduleAccessEnabled: boolean): Record<string, string> {
  const entitlements: Record<string, string> = {};
  for (const row of rows) {
    const key = row.key.trim();
    if (reservedEntitlement(key, moduleAccessEnabled)) {
      throw new Error("Manage module grants from Modules.");
    }
    if (key) entitlements[key] = row.value.trim();
  }
  return entitlements;
}
